import React from 'react';

import {COLORS} from '../../../constants/color';
import {
  TouchableOpacity,
  StyleSheet,
  Text,
  ActivityIndicator,
} from '../react-native-components';

const styles = StyleSheet.create({
  buttonContainer: {
    height: 48,
    borderRadius: 6,
    alignItems: 'center',
    justifyContent: 'center',
  },
  primaryButtonContainer: {
    backgroundColor: COLORS.PRIMARY,
  },
  secondaryButtonContainer: {
    backgroundColor: COLORS.WHITE_HIGH,
  },
  disabledButtonContainer: {
    backgroundColor: COLORS.BLACK_DISABLED,
  },
  text: {
    color: COLORS.WHITE_HIGH,
    fontSize: 14,
    fontWeight: '600',
    lineHeight: 24,
  },
  secondaryButtonText: {
    color: COLORS.PRIMARY,
  },
});

const Button = ({
  title,
  onPress,
  style = {},
  isLoading = false,
  isPrimary = true,
  isDisabled = false,
  isSecondary = false,
}) => {
  return (
    <TouchableOpacity
      onPress={!isLoading && !isDisabled ? onPress : null}
      style={[
        styles.buttonContainer,
        isPrimary && styles.primaryButtonContainer,
        isDisabled && styles.disabledButtonContainer,
        isSecondary && styles.secondaryButtonContainer,
        style.buttonContainer,
      ]}>
      {isLoading ? (
        <ActivityIndicator  color={isPrimary ? COLORS.WHITE_HIGH: COLORS.BLACK_HIGH}/>
      ) : (
        <Text
          style={[
            styles.text,
            isSecondary && styles.secondaryButtonText,
            style.text,
          ]}>
          {title}
        </Text>
      )}
    </TouchableOpacity>
  );
};

export default Button;
